import React from 'react';

import PoiInfo from './poiInfo';
import PoiHeader from './header';

const PoiAdd = () => (
  <div className="container-fluid px-0">
    <div className="row">
      <div className="col-12">
        <PoiHeader />
      </div>
    </div>

    <div className="row">
      <div className="col-12  pl-lg-5">
        <PoiInfo />
      </div>
    </div>
  </div>
);

export default PoiAdd;
